import { EmailModal } from "./components/email";
import { HorarioModal } from "./components/horario";
import { MidiaModal } from "./components/midia";
import { TelefoneModal } from "./components/telefone";


interface CadastroContatoProps {
  type: string;
  title: string;
  isToSave?: boolean
  isOperador?: boolean
  app?: string
}

export const CadastroContato = ({ type, title, isToSave, isOperador, app }: CadastroContatoProps) => {
  return (
    <div className="flex flex-col items-center">
      {/* <div className="-mt-6 mb-4 w-full border-b ">
        <h2 className="mb-4 text-center text-lg font-medium text-gray-800 ">
          {title}
        </h2>
      </div> */}

      <div className="w-full">
        {type === "Telefone" && <TelefoneModal isToSave={isToSave} isOperador={isOperador} app={app} />}
        {type === "Mídia" && <MidiaModal />}
        {type === "Email" && <EmailModal isToSave={isToSave} app={app} isOperador={isOperador} />}
        {type === "Horário" && <HorarioModal />}

      </div>
    </div>
  );
};
